import {Component, Input} from '@angular/core';
import {ApiService} from '../../service/api.service';
import {WelfareProject} from '../../class/welfare-project';
import {AbstractItemList} from '../../class/gui/abstract-item-list';

@Component({
  selector: 'app-welfy-project-list',
  templateUrl: './welfy-pro-project-list.component.html',
  styleUrls: ['./welfy-pro-project-list.component.css']
})
export class WelfyProProjectListComponent extends AbstractItemList<WelfareProject> {

  @Input()
  title: string;

  @Input()
  appName: string;

  @Input()
  showOpenButton = false;

  constructor(private apiService: ApiService) {
    super();
  }

  loadItems() {
    this.apiService.loadSavedProjects(this.appName).subscribe(value => {
      this.items = value;
    });
  }
}
